import React, { useState, useEffect, useRef } from 'react';
import "../../css/contenteditable.css"
import { useThemeMode } from '../../../_metronic/partials';
type EditableDivProps = {
  placeholder: string;
  onChange?: (value: string) => void;
  initialContent?: string;
  className?: string;
};

const EditableDiv: React.FC<EditableDivProps> = ({ placeholder, onChange, initialContent, className}) => {
  const [isEmpty, setIsEmpty] = useState<boolean>(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<string>(initialContent || "");
  const { mode } = useThemeMode();
  useEffect(() => {
  if (contentRef.current) {
    const newValue = initialContent || '';
    contentRef.current.innerHTML = newValue;
    setIsEmpty(newValue === '');
  }
}, [initialContent]);

  const handleInput = () => {
    if (contentRef.current) {
      const newValue = contentRef.current.innerHTML;
      setIsEmpty(newValue === '');
      if (newValue !== '') {
        contentRef.current?.removeAttribute('data-placeholder');
      } else {
        contentRef.current?.setAttribute('data-placeholder', placeholder);
      }
    }
  };

  const handleBlur = () => {
    if (isEmpty) {
      setContent('');
      contentRef.current?.setAttribute('data-placeholder', placeholder);
    }
    else{
      if (contentRef.current){
      onChange && onChange(contentRef.current.innerHTML);
      setContent(contentRef.current.innerHTML);
      }
    }
  };
  const bgStyle: any =
  mode === 'light' ? { backgroundColor: '#f5f8fa' } : { backgroundColor: null };
  return (
    <div
      ref={contentRef}
      contentEditable
      data-placeholder={isEmpty ? placeholder : undefined}
      onBlur={handleBlur}
      onInput={handleInput}
      style={{...bgStyle}}
      dangerouslySetInnerHTML={{ __html: content }}
      className= {`content-editable ${className} border rounded p-5`}
    />
  );
};

export default EditableDiv;